import React from 'react';
import SideMenu from "../../components/SideMenu/SideMenu"
import ClientsContent from "./ClientsContent"
import styles from './Clients.module.scss';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function Clients(props) {
  const location = useLocation();
  useEffect(() => {
    document.title = 'Clientes';
  }, [location]);
  return (
    <div className={styles.root}>
      <SideMenu />
      <ClientsContent />
    </div>
  );
}

export default Clients;